import { useEffect, type ReactNode } from 'react';
import { Footer } from '@/components/elements/Footer';
import { Header } from '@/components/elements/Header';

interface MainLayoutProps {
  children: ReactNode;
  pageClassName?: string;
  showHeader?: boolean;
  showFooter?: boolean;
}

export const MainLayout = ({
  children,
  pageClassName = '',
  showHeader = true,
  showFooter = true,
}: MainLayoutProps) => {
  useEffect(() => {
    // bodyにlayoutクラスを追加
    // 注: クリーンアップでは削除しない（他のページでも必要なため）
    document.body.classList.add('layout');
  }, []);

  return (
    <div className="wrap">
      {showHeader && <Header />}
      <div className={`page ${pageClassName}`}>
        <main className="page__main">
          <div className="page__content">{children}</div>
        </main>
      </div>
      {showFooter && <Footer />}
    </div>
  );
};
